export enum SearchParamsKeysEnum {
  token = 'token',
  lang = 'lang',
  pickem_id = 'pickem_id',
  tab = 'tab',
}
